module.exports = __webpack_public_path__ + "img/86be804067cadb0cd17d4b2734b6785f.c0195afb.png";